import React from 'react';
import { userAppContext } from '../../context/Context';
import { DATASETS } from '../Constants';
import DetailGene from './DetailGene';
import DetailDisgenet from './DetailDisgenet';
import DetailVariant from './DetailVariant';
import DetailDrug from './DetailDrug';
import { getTitle } from '../Constants';
import SharedModal from '../Modal/SharedModal';
import { useSidebarDetailContent } from '../../hooks/useSidebarDetailContent';

interface SideBarContentProps {
  selectedInfoItem: any;
  view: string;
  showModalExample: boolean;
  setShowModalExample: (show: boolean) => void;
}

function SideBarContent({ selectedInfoItem, view, showModalExample, setShowModalExample }: SideBarContentProps) {
  const { authorization, isAuthenticated, setIsAuthenticated } = userAppContext();

  const { dataSource, vocabulary, tipo } = useSidebarDetailContent({
    selectedInfoItem,
    view,
    authorization,
    isAuthenticated,
    onAuthStateChange: setIsAuthenticated,
  });

  // Extract the values to pass to detail components
  const detailValues = tipo === DATASETS.CHEMICALS ? dataSource : dataSource.payload;

  const content = (
    <>
      {tipo === DATASETS.DISEASES && (
        <DetailDisgenet values={detailValues} vocabulary={vocabulary} />
      )}
      {tipo === DATASETS.GENES && (
        <DetailGene values={detailValues} />
      )}
      {tipo === DATASETS.VARIANTS && (
        <DetailVariant values={detailValues} vocabulary={vocabulary} />
      )}
      {tipo === DATASETS.CHEMICALS && <DetailDrug values={detailValues} />}
    </>
  );

  return (
    <>
      {showModalExample && selectedInfoItem && (
        <SharedModal
          open={showModalExample}
          setOpen={setShowModalExample}
          title={getTitle(selectedInfoItem)}
          content={content}
        />
      )}
    </>
  );
}

export default SideBarContent;
